import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoajantaelloracabs() {



  const cardData =
  {
    keyword: 'Pune to Ajanta Ellora Cabs',
    heading: 'Sai Trupti Cabs: Pune to Ajanta Ellora Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Ajanta & Ellora Caves cab hire services, designed to make your out-station and heritage-site journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors, ample luggage space, and ideal for longer drives and sightseeing. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Ajanta & Ellora. With transparent one-way or round-trip fares, flexible booking options (custom itineraries included), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Ajanta & Ellora convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Ajanta Ellora with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves – UNESCO Rock-Cut Buddhist Monasteries",
    "description": "The Ajanta Caves are a breathtaking ensemble of 30 rock-cut Buddhist monuments hewn into the horseshoe-shaped gorge of the Waghora River in Maharashtra.:contentReference[oaicite:1]{index=1} Dating back to the 2nd century BCE and renewed in the 5th–6th century CE, they were used as monastic retreats and sanctuaries of meditation.:contentReference[oaicite:2]{index=2} Inside, you’ll discover magnificent mural paintings and sculptures that depict the Jataka tales and lives of Buddha, with delicate gestures, vivid colours and ancient craftsmanship.:contentReference[oaicite:3]{index=3} The narrow steps, darkened halls, carved pillars and stupa-sanctums create a spiritual atmosphere that invites reflection. The caves were hidden by jungle for centuries and rediscovered in 1819, adding to their mystic charm.:contentReference[oaicite:4]{index=4} Visiting them means stepping into an 800-year story of religion, art and rock-architecture. From the forested approach to the echoing chambers, Ajanta is not just a site — it’s a pilgrimage of aesthetic and spiritual heritage."
  },
  {
    "title": "Ellora Caves – Rock-Cut Temples of Three Faiths",
    "description": "The Ellora Caves span an astonishing 2 km of basalt cliff near Aurangabad, forming a monumental complex of 34 monuments — Buddhist, Hindu and Jain — carved between the 6th and 10th centuries.:contentReference[oaicite:5]{index=5} Among them, Cave 16 (the Kailasa Temple) is the world’s largest monolithic rock excavation, sculpted top-down from solid rock.:contentReference[oaicite:6]{index=6} The carvings tell stories from the Ramayana and Mahabharata, the ride of gods and demons, and depict a level of engineering and artistry rarely matched.:contentReference[oaicite:7]{index=7} Unlike Ajanta’s mostly Buddhist iconography, Ellora’s coexistence of three faiths makes it a powerful symbol of religious harmony and architectural ambition. The vast courtyard, the sculpted elephants, the light-and-shadow play of cliff faces — all create an immersive journey into ancient India’s heart."
  },
  {
    "title": "The Kailasa Temple (Cave 16, Ellora)",
    "description": "The Kailasa Temple is the crown jewel of the Ellora complex — a chariot-shaped monument carved from a single rock, standing in the open air as if a freestanding temple rather than a cave.:contentReference[oaicite:8]{index=8} Building it required removing over 200 000 tons of rock, and generations of artisans who carved its pillars, sculptures, and corridors from top to bottom over centuries.:contentReference[oaicite:9]{index=9} The rich friezes depict the epics, the gods, the battles and the devotion; each detail invites awe and contemplation. Visiting the Kailasa Temple is like walking into a living myth — the scale, the workmanship and the setting make it unforgettable."
  },
  {
    "title": "Cave 1 & 2, Ajanta – Masterpieces of Mural Painting",
    "description": "Caves 1 and 2 at Ajanta are among the most artistically significant — filled with wall murals of Bodhisattvas, decorated ceilings, and carved pillars that reflect the Florentine-level sophistication of ancient India.:contentReference[oaicite:10]{index=10} The paintings capture subtle emotion, elegant posture, and deep spirituality — for example the famed Bodhisattva Padmapani in Cave 1.:contentReference[oaicite:11]{index=11} The dim lighting and texture of basalt enhance the ambience, making the art seem alive. These caves talk not only of faith but also of craft, patronage and visual storytelling. Spending time here feels like being in a gallery where each wall whispers ancient narratives."
  },
  {
    "title": "Monastic Viharas and Chaityagrihas of Ajanta",
    "description": "Beyond the headline caves, Ajanta hosts monasteries (viharas) and prayer halls (chaityagrihas) hewn into the cliff face, each designed with a central nave, side aisles and stupa or shrine at the end.:contentReference[oaicite:12]{index=12} The earliest caves (2nd century BCE) are simpler, while the later phase (5th–6th century CE) displays rich mural decoration and refined carving.:contentReference[oaicite:13]{index=13} The layout served monks during monsoon retreats and provided shelter, worship and creative space. These halls still echo with the silence of meditation and echo with footsteps of ancient devotions. For travellers, the architecture invites one to think, pause, and feel the weight of years."
  },
  {
    "title": "Reliefs & Sculptures at Ellora – Hindu, Buddhist & Jain Art",
    "description": "Walking through the Ellora complex is a journey across faith and form — Buddhist caves with stupa halls, Hindu temples with towering shikharas, and Jain caves with elegant simplicity.:contentReference[oaicite:14]{index=14} The relief panels of Hindu deities, Jain Tirthankaras and Buddhist groups show a mastery of iconography, narrative, and rock-cut precision. From the sculpted valleys to carved colonnades and relief friezes showing mythic battles, every inch is loaded with meaning. Visitors often pause at the details — a horse carved in relief, the smirk of a god, the worn step of devotees — reminders of centuries of devotion. It’s a place where art, religion and geology converge."
  },
  {
    "title": "Setting, Landscape & Archaeological Wonder",
    "description": "Both Ajanta and Ellora are marvels not just for what was carved, but where and how they were carved. Ajanta’s caves nestle in a forested gorge with waterfalls and basalt cliffs; :contentReference[oaicite:15]{index=15} Ellora’s towering basalt escarpment rises above a plateau, approached by stone steps and lined with cliff-cut caves.:contentReference[oaicite:16]{index=16} The engineering of top-down excavation, the clarity of vision, the integration with landscape, and the endurance of stone across millennia — all make the sites more than just tourist stops. They become dialogues between nature, human ambition, faith and time."
  },
  {
    "title": "Visiting Experience & Travel Tips",
    "description": "Visiting Ajanta & Ellora calls for early arrival, comfortable shoes and time to absorb the art. The complexes are located near Aurangabad (about 100 km apart), making them a great combined itinerary.:contentReference[oaicite:18]{index=18} Morning light inside caves brings out colours; afternoon shadows deepen the mood. On-site guides or audio commentary add depth. Respect the space — no large bags, limited lighting, and silence enhance your visit. Bring water, move slowly, and let the stones speak to you. Because these sites are fragile, minimal touch helps preserve paintings and carvings for future generations."
  },
  {
    "title": "Heritage, Spirituality & Cultural Legacy",
    "description": "Ajanta & Ellora represent more than rock-cut art — they embody a cultural legacy of faith, patronage, human creativity and co-existence. Ajanta reflects Buddhist monastic calm, Ellora demonstrates pluralism with Buddhist, Hindu and Jain monuments. Together they show ancient India’s capacity for spirituality, artistry and interconnectedness. Visiting them gives more than memories — it gives perspective. Standing in a dim hall carved deep in basalt, looking at centuries-old paintings or a massive monolith temple, you touch a point where time, belief and talent met. These caves whisper of human possibility."
  },
  {
    "title": "Conservation & Future Guardianship",
    "description": "Given their antiquity and fragility, both Ajanta and Ellora are under continuous conservation by the Archaeological Survey of India and other heritage bodies.:contentReference[oaicite:20]{index=20} Preservation includes visitor-flow control, micro-climate management, protective renovation and education efforts. The sites face challenges from weathering, tourist pressure and natural decay. Efforts such as limiting lighting, creating replicas, and monitoring rock stability are underway. They are not mere attractions — they are living heritage to be respected and sustained by each visitor’s awareness."
  }
],



"services": [
  {
    "name": "Pune to Ajanta Ellora Cabs",
    "description": "Reliable cab service from Pune to Ajanta Ellora providing professional drivers, luggage assistance, and AC/non-AC vehicle options. Ideal for sightseeing trips, family vacations, group tours, and corporate travel. Ensures a safe, comfortable, and punctual journey with flexible pickup and drop locations, along with transparent fares."
  },
  {
    "name": "Pune to Ajanta Ellora Taxi Service",
    "description": "Premium taxi service from Pune to Ajanta Ellora featuring well-maintained vehicles, experienced drivers, luggage support, and AC/non-AC options. Perfect for leisurely sightseeing trips, heritage tours, and long-distance travel, offering hassle-free online booking, comfortable seating, and a smooth journey throughout."
  },
  {
    "name": "Pune to Ajanta Ellora Car Hire",
    "description": "Hire cars from Pune to Ajanta Ellora including sedans, SUVs, Innova, and Ertiga with professional drivers, luggage assistance, AC/non-AC options, and flexible schedules. Provides a convenient and safe travel experience for families, friends, and corporate clients, ensuring reliable and timely transportation for your trip."
  },
  {
    "name": "Pune to Ajanta Ellora AC Cab",
    "description": "Comfortable AC cab service from Pune to Ajanta Ellora with professional drivers, luggage support, and flexible pickup/drop locations. Ideal for long-distance travel, family trips, and corporate outings, offering a cool, relaxing ride with punctual arrivals and a safe journey throughout."
  },
  {
    "name": "Pune to Ajanta Ellora Non AC Cab",
    "description": "Budget-friendly non-AC cab service from Pune to Ajanta Ellora featuring reliable vehicles, professional drivers, luggage assistance, and flexible schedules. Perfect for travelers seeking economical yet safe and comfortable outstation travel, with transparent fares and dependable service."
  },
  {
    "name": "Luxury Cab Pune to Ajanta Ellora",
    "description": "Premium luxury cab service from Pune to Ajanta Ellora offering top-class vehicles, AC service, professional chauffeurs, luggage support, and timely pickups. Ideal for weddings, VIP travel, corporate trips, and special occasions, ensuring a luxurious and hassle-free long-distance journey."
  },
  {
    "name": "Pune to Ajanta Ellora Innova Cab",
    "description": "Spacious Innova cab from Pune to Ajanta Ellora accommodating 6-7 passengers with AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, and transparent fares. Perfect for family trips, group travel, and corporate outings requiring comfort, space, and reliability."
  },
  {
    "name": "Pune to Ajanta Ellora Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune to Ajanta Ellora featuring AC/non-AC options, professional drivers, luggage support, and flexible pickup/drop locations. Ideal for small families, group trips, and leisure travel, providing a safe, convenient, and pleasant long-distance journey."
  },
  {
    "name": "Affordable Pune to Ajanta Ellora Cab",
    "description": "Economical cab service from Pune to Ajanta Ellora offering AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and transparent fares. Perfect for cost-conscious travelers seeking safe and reliable outstation transportation without compromising comfort."
  },
  {
    "name": "Pune to Ajanta Ellora Outstation Cab",
    "description": "Outstation cab service from Pune to Ajanta Ellora with AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and online booking. Ideal for weekend trips, heritage tours, and long-distance travel, ensuring comfort, safety, and punctual service throughout the journey."
  },
  {
    "name": "Pune to Ajanta Ellora One Way Cab",
    "description": "Convenient one-way cab service from Pune to Ajanta Ellora with AC/non-AC options, professional drivers, luggage support, and transparent fares. Perfect for travelers requiring a one-way drop without worrying about return transportation or extra charges, making travel flexible and stress-free."
  },
  {
    "name": "Pune to Ajanta Ellora Drop Cab",
    "description": "Drop cab service from Pune to Ajanta Ellora featuring AC/non-AC vehicles, professional drivers, luggage assistance, and flexible schedules. Ensures safe, comfortable, and timely travel to your destination with clear pricing and hassle-free booking for long-distance journeys."
  },
  {
    "name": "Pune to Ajanta Ellora Corporate Cab",
    "description": "Corporate cab service from Pune to Ajanta Ellora offering AC/non-AC vehicles, professional chauffeurs, luggage assistance, flexible pickup/drop schedules, and online booking. Ideal for business trips, corporate tours, and client travel, providing comfort, punctuality, and a reliable journey for professional needs."
  },
  {
    "name": "Pune to Ajanta Ellora Wedding Cab",
    "description": "Premium wedding cab service from Pune to Ajanta Ellora with luxurious vehicles, AC/non-AC options, professional drivers, luggage support, and timely pickups. Perfect for weddings, transporting family, guests, and VIPs safely and comfortably, ensuring a stylish and hassle-free travel experience."
  },
  {
    "name": "Pune to Ajanta Ellora Online Booking",
    "description": "Book your Pune to Ajanta Ellora cab online instantly with secure payments, multiple AC/non-AC vehicle options, professional drivers, luggage support, and flexible pickup/drop points. Convenient for planning trips in advance or on short notice, ensuring complete transparency, ease of travel, and peace of mind."
  }
],
"tableData": [
  ["Pune to Ajanta Ellora Cabs", "Pune to Ajanta Ellora Taxi Service"],
  ["Pune to Ajanta Ellora Car Hire", "Pune to Ajanta Ellora AC Cab"],
  ["Pune to Ajanta Ellora Non AC Cab", "Luxury Cab Pune to Ajanta Ellora"],
  ["Pune to Ajanta Ellora Innova Cab", "Pune to Ajanta Ellora Ertiga Cab"],
  ["Affordable Pune to Ajanta Ellora Cab", "Pune to Ajanta Ellora Outstation Cab"],
  ["Pune to Ajanta Ellora One Way Cab", "Pune to Ajanta Ellora Drop Cab"],
  ["Pune to Ajanta Ellora Corporate Cab", "Pune to Ajanta Ellora Wedding Cab"],
  ["Pune to Ajanta Ellora Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Ajanta Ellora Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Ajanta and Ellora — ideal for sightseeing, historical tours, and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Ajanta and Ellora trips, starting at affordable rates depending on the vehicle type — no hidden charges or surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for your historical tour."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Ajanta and Ellora route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at Ajanta, Ellora, or back to Pune as per your travel plan."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your sightseeing trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Ajanta Ellora cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]


















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Ajanta Ellora cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Ajanta Ellora cab services for one-way trips, round trips, and group tours.',
  },
  {
    question: 'How can I book a Pune to Ajanta Ellora cab with Sai Trupti Cabs?',
    answer: 'You can easily book a cab from Pune to Ajanta Ellora through our website, mobile app, or by contacting our 24×7 customer support team for quick confirmation.',
  },
  {
    question: 'What types of cabs are available for Pune to Ajanta Ellora travel?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your travel needs, group size, and budget for sightseeing tours.',
  },
  {
    question: 'Are the drivers experienced for Pune to Ajanta Ellora trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance and sightseeing routes, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Ajanta Ellora for family or group tours?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and leisure sightseeing from Pune to Ajanta Ellora.',
  },
  {
    question: 'Is the Pune to Ajanta Ellora cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune to Ajanta Ellora for flexible travel plans and convenient scheduling.',
  },
  {
    question: 'What are the Pune to Ajanta Ellora cab fares?',
    answer: 'Our Pune to Ajanta Ellora cab fares start from approximately ₹5,000 for sedans and ₹6,500–₹8,000 for SUVs and larger vehicles, depending on the vehicle type and travel duration.',
  },
  {
    question: 'What payment methods are accepted for Pune to Ajanta Ellora cab hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers for secure and hassle-free bookings.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Ajanta Ellora cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety protocols to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Pune to Ajanta Ellora cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Ajanta Ellora cab trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Deshmukh',
    feedback: 'I booked a Pune to Ajanta Ellora cab with Sai Trupti Cabs. The ride was comfortable and the driver was punctual and knowledgeable about the route.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Snehal Patil',
    feedback: 'Sai Trupti Cabs made our Pune to Ajanta Ellora sightseeing tour hassle-free. Excellent service and a very professional driver.',
    rating: 5,
  },
];
























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ajanta Ellora Cabs",
  "image": "https://saitrupticabs.com/assets/images/pune-to-ajanta-ellora-cab.jpg",
  "description": "Book reliable cab services from Pune to Ajanta Ellora. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-ajanta-ellora-cabs"
  }
};




  return (
    <div>
      <Helmet>
  <title>Pune to Ajanta Ellora Cabs | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book reliable cab services from Pune to Ajanta Ellora. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Ajanta Ellora Cabs, Pune to Ajanta Ellora Taxi Service, Pune to Ajanta Ellora Car Hire, Pune to Ajanta Ellora AC Cab, Pune to Ajanta Ellora Non AC Cab, Luxury Cab Pune to Ajanta Ellora, Pune to Ajanta Ellora Innova Cab, Pune to Ajanta Ellora Ertiga Cab, Affordable Pune to Ajanta Ellora Cab, Pune to Ajanta Ellora Outstation Cab, Pune to Ajanta Ellora One Way Cab, Pune to Ajanta Ellora Drop Cab, Pune to Ajanta Ellora Corporate Cab, Pune to Ajanta Ellora Wedding Cab, Pune to Ajanta Ellora Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoajantaelloracabs;